import Ethnicity from 'src/app/models/ethnicity';
import { map, filter, cloneDeep, some } from 'lodash';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { NgForm } from '@angular/forms';
import { Component, ViewEncapsulation, Input, OnInit, OnChanges, Output, EventEmitter, ViewChild } from '@angular/core';
import SpecialOpenEnrollment from 'src/app/models/selfPay';
import SelfPayFormDependent from 'src/app/models/selfPayFormDependent';
import SelfPayFormSubscriber from 'src/app/models/selfPayFormSubscriber';
import SelfPayPaymentType from 'src/app/models/selfPayPaymentType';
import GenderIdentity from 'src/app/models/genderIdentity';
import BirthSex from 'src/app/models/birthSex';
import SelfPay from 'src/app/models/selfPay';
import Plan from 'src/app/models/plan';
import { env } from 'src/env/development';
import * as dayjs from 'dayjs';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'self-pay-pdf',
  templateUrl: 'selfPay.pdf.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None
})
export class SelfPayPDFComponent implements OnChanges {
  @Input() selfPay: SelfPay;
  @Input() selfPayPaymentTypes: SelfPayPaymentType[];
  @Input() birthSexes: BirthSex[];
  @Input() genderIdentities: GenderIdentity[];
  @Input() availablePlans: Plan[];
  @Input() ethnicities: Ethnicity[];
  @Input() lookups;
  selectedMedicalPlan: Plan;
  selectedDentalPlan: Plan;
  selectedVisionPlan: Plan;
  selectedMedicalPlans: string;
  isPebbLwopVision: boolean = false;
  genderIdentityDisabled = false;

  existingDependents: SelfPayFormDependent[];
  newDependents: SelfPayFormDependent[];
  birthSex: BirthSex;
  genderIdentity: GenderIdentity;
  displayRaceEthnicity = false;
  isOE: boolean;
  isLWOP: boolean;
  
  constructor(private coreService: CoreService) {
    this.genderIdentityDisabled = this.coreService.getGenderValue();
  }

  ngOnChanges() {
    this.isOE = this.selfPay?.selfPayType?.selfPayTypeCode && ['OE', 'OER', 'OEC', 'OEU'].includes(this.selfPay?.selfPayType?.selfPayTypeCode);
    this.isLWOP = ['SOEU','OEU','U'].includes(this.selfPay?.selfPayType.selfPayTypeCode);
    this.isPebbLwopVision = this.selfPay?.agency?.agencyCode === 'PEBB' && this.isLWOP;
    this.existingDependents = filter(this.selfPay.formJson.dependents, (d: SelfPayFormDependent) => d.memberId);
    this.newDependents = filter(this.selfPay.formJson.dependents, (d: SelfPayFormDependent) => !d.memberId);
    this.selectedMedicalPlan = cloneDeep(this.availablePlans.find(o=>o.planId===this.selfPay.formJson.medicalPlan.planId));
    this.selectedDentalPlan = cloneDeep(this.availablePlans.find(o=>o.planId===this.selfPay.formJson.dentalPlan.planId));
    this.selectedVisionPlan = cloneDeep(this.availablePlans.find(o=>o.planId===this.selfPay.formJson.visionPlan.planId));
    this.selectedMedicalPlans = this.selfPay.formJson.medicalPlans && this.selfPay.formJson.medicalPlans.length > 0 ?
      map(this.selfPay.formJson.medicalPlans,'planName').join(" and ") :
      this.selectedMedicalPlan?.planName;
    this.setSubscriberSexAndGender();

    this.selfPay.formJson?.dependents && this.selfPay.formJson?.dependents.forEach(dep => {
      dep.relationshipTypeName ??= this.lookups.relationshipTypes.filter(rt => rt.relationshipTypeCode === dep.relationshipTypeCode)[0].relationshipTypeName;
      if (dep.relationshipQualifyReasonId && this.lookups.relationshipQualifyReasons && this.lookups.relationshipQualifyReasons.length > 0) {
        const filteredQualReasons = this.lookups.relationshipQualifyReasons.filter(rt => rt.relationshipQualifyReasonId === dep.relationshipQualifyReasonId);

        if (filteredQualReasons.length > 0)
          dep.relationshipQualifyReasonName = filteredQualReasons[0].relationshipQualifyReasonName;
      }
    });

    //Bug 45473 - race ethnicity component currently disabled in pdf
    // if((some(env.selfPayRetireeRequestCodes,(cd)=> cd == this.selfPay.selfPayType?.selfPayTypeCode) || (this.selfPay.isPEBB && some(env.cobraSelfPayTypeCodes,(cd)=> cd == this.selfPay.selfPayType?.selfPayTypeCode))) && 
    //   this.subscriberOrDependentsAreMedicareEnrolled() && some(this.lookups?.applicationSetting, (as) => as.applicationSettingCode === 'MAPD' && as.response?.responseCode === 'Y'))
    // {
    //   this.displayRaceEthnicity = true;
    //   if (this.selfPay?.formJson?.dependents[0]) {
    //     this.selfPay?.formJson?.setEthnicityDependents();
    //   }
    // }
  }

  isBool(val): boolean {
    return typeof val === 'boolean';
  }

  setSubscriberSexAndGender() {
    this.birthSex = this.birthSexes.find((r) => r.birthSexId === this.selfPay.formJson.subscriber.birthSexId);
    if (this.selfPay.formJson.subscriber.genderIdentityId) {
      this.genderIdentity = this.genderIdentities.find((r) => r.genderIdentityId === this.selfPay.formJson.subscriber.genderIdentityId);
    }
  }

  getBirthSexName(birthSex: string) {
    return this.birthSexes.find((r) => r.birthSexCode === birthSex)?.birthSexName;
  }

  getGenderIdentityName(genderIdentity: string) {
    if (genderIdentity?.length === 1) {
      return this.genderIdentities.find((r) => r.genderIdentityCode === genderIdentity)?.genderIdentityName;
    } else {
      return this.genderIdentities.find((r) => r.genderIdentityId === genderIdentity)?.genderIdentityName;
    }
  }

  subscriberOrDependentsAreMedicareEnrolled(): boolean {
    return this.selfPay.formJson?.subscriber?.medicarePartAInd || some(this.selfPay.formJson?.dependents, (d: SelfPayFormDependent) => d?.memberMedicare?.medicarePartAEnrolledInd);
  }
}
